module.exports = __webpack_public_path__ + "static/media/exit-gray.631175ff.svg";